import axios from 'axios'
import { accessToken } from '@/lib/authToken'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor — inject the 42QLabs access token, refreshing it if it is stale.
// One issuer for the whole app; see lib/authToken.
api.interceptors.request.use(async (config) => {
  const token = await accessToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// Response interceptor — handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // A 401 means the session is gone. Two details matter here: the app is served under
    // /dashboard/ in production, so a bare '/login' would leave the app entirely; and a
    // redirect while already on the login page turns a stale token into a reload loop.
    if (error.response?.status === 401 && !window.location.pathname.endsWith('/login')) {
      window.location.href = `${import.meta.env.BASE_URL}login`.replace(/\/{2,}/g, '/')
    }
    return Promise.reject(error)
  }
)

export default api
